import { Controller } from "@hotwired/stimulus"

// Подключаем к коллекции контроллеров Stimulus
export default class extends Controller {
  static targets = ["picker", "hiddenField"]

  connect() {
    console.log("Datepicker controller connected")
    this.initializeDatepicker()
  }

  disconnect() {
    // Очистка при отключении
    if (this.pickerTarget && $(this.pickerTarget).data('datepicker')) {
      $(this.pickerTarget).datepicker('destroy')
    }
  }

  initializeDatepicker() {
    const pickerElement = $(this.pickerTarget)
    
    pickerElement.datepicker({
      format: 'mm/yyyy',
      startView: 'months',
      minViewMode: 'months',
      autoclose: true,
      language: 'ru',
      todayHighlight: true
    }).on('changeDate', (e) => {
      this.updateHiddenField(e.date)
    })
  }

  updateHiddenField(selectedDate) {
    if (this.hasHiddenFieldTarget) {
      const year = selectedDate.getFullYear()
      const month = (selectedDate.getMonth() + 1).toString().padStart(2, '0')
      const formattedDate = `${year}-${month}-01`
      
      this.hiddenFieldTarget.value = formattedDate
      console.log("Updated hidden field with:", formattedDate)
    }
  }

}
